/**
 * Normalize the pointer events in order to get the properties of a single finger touch on touches devices
 * @param {object} - event - event object
 * @returns {object} a single pointer event
 */
export default function pointerEvent(event) {
    return event.targetTouches ? event.targetTouches[0] : event;
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/dom/pointer-event.js